import { render, staticRenderFns } from "./distributionMap.vue?vue&type=template&id=6fca8875&scoped=true&"
import script from "./distributionMap.vue?vue&type=script&lang=js&"
export * from "./distributionMap.vue?vue&type=script&lang=js&"
import style0 from "./distributionMap.vue?vue&type=style&index=0&id=6fca8875&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fca8875",
  null
  
)

export default component.exports